import request from '@/utils/request'
import { getShopId } from '@/api/shop/shopApi'

/**
 * 获取拼团商品列表
 * @param {Object} params 查询参数
 * @returns {Promise} 返回拼团商品列表
 */
export function listProductGroup(params) {
  return new Promise((resolve, reject) => {
    params.shopId = getShopId()
    request({
      url: '/productGroup.listProductGroup',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 添加拼团商品
 * @param {Object} data 拼团商品数据
 * @returns {Promise} 返回操作结果
 */
export function saveProductGroup(data) {
  return new Promise((resolve, reject) => {
    data.shopId = getShopId()
    request({
      url: '/productGroup.saveProductGroup',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(res.msg)
      }
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 更新拼团商品
 * @param {Object} data 拼团商品数据
 * @returns {Promise} 返回操作结果
 */
export function updateProductGroup(data) {
  return new Promise((resolve, reject) => {
    data.shopId = getShopId()
    request({
      url: '/productGroup.updateProductGroup',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(res.msg)
      }
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除拼团商品
 * @param {Object} data 删除参数
 * @returns {Promise} 返回操作结果
 */
export function deleteProductGroup(data) {
  return new Promise((resolve, reject) => {
    data.shopId = getShopId()
    request({
      url: '/productGroup.deleteProductGroup',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(res.msg)
      }
    }).catch(error => {
      reject(error)
    })
  })
}